import { Order } from "../../entity/Order";
import { toDate } from "../../utils/GlobalFunctions";
import { OrderDto } from "../dto/Order.Dto";

export const mapToOreders = (orderDto: OrderDto[]): Order[] => {
  return orderDto
    .map((order) => ({
      id: order.id,
      userId: order.userId,
      productIds: order.productIds,
      address: order.address,
      name: order.name,
      phone: order.phone,
      governorate: order.governorate,
      totalAmount: order.totalAmount,
      cart: order.cart,
      notes: order.notes || "",
      status: order.status,
      history: order.history,
      createdAt: toDate(order.createdAt!!),
      updatedAt: toDate(order.updatedAt!!),
      storeId: order.storeId,
      deliveryCompany: order.deliveryCompany || "",
      deliveryPrice: order.deliveryPrice || 0,
      deliveryReference: order.deliveryReference || "",
      tentativesNumber: order.tentativesNumber || 0,
    }))
    .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
};
